import React, { ReactNode } from 'react';

import Classes from './VerticalScrollList.module.scss';

type TProps = {
  children: ReactNode;
};

const VerticalScrollList = ({ children }: TProps) => <div className={Classes.root}>{children}</div>;

export default VerticalScrollList;
